import { ThemeUIStyleObject } from "theme-ui";

export const layoutContainerStyles: ThemeUIStyleObject = {
  overflowX: "hidden",
};

export const headerContainerStyles: ThemeUIStyleObject = {
  position: "absolute",
  zIndex: "header",
  top: 0,
  left: 0,
  right: 0,
  width: "100%",
};

export const mainContainerStyles: ThemeUIStyleObject = {
  position: "relative",
  zIndex: 1,
  bg: "white",
  px: [3, 6],
  pt: 0,
  pb: [3, 6],
};

export const heroContainerStyles: ThemeUIStyleObject = {
  position: ["relative"],
  top: "0",
  zIndex: 1,
};

export const heroContainerFaqStyles: ThemeUIStyleObject = {
  ...heroContainerStyles,
  bg: "darkGreen",
  "& + #layout-page-content": {
    borderTop: 0,
  },
};

export const heroContainerStoryStyles: ThemeUIStyleObject = {
  ...heroContainerStyles,
  "& + #layout-page-content": {
    borderTop: 0,
  },
};

export const contentContainerStyles: ThemeUIStyleObject = {
  position: "relative",
  zIndex: 2,
  transform: "translate3d(0,0,0)", // Safari ...
  borderColor: "white",
  borderStyle: "solid",
  borderTopWidth: ["15px", "30px"],
};

export const footerContainerStyles: ThemeUIStyleObject = {
  position: ["static", "static", "sticky"],
  bottom: "0",
};
